module.exports = __webpack_public_path__ + "img/ambi_logo.4c801e95.png";